import { render, staticRenderFns } from "./MessageModal.vue?vue&type=template&id=3ec8b9a8&scoped=true&"
import script from "./MessageModal.vue?vue&type=script&lang=js&"
export * from "./MessageModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageModal.vue?vue&type=style&index=0&id=3ec8b9a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec8b9a8",
  null
  
)

export default component.exports